/**
 * Component Registry for Metropolitan
 * 
 * Inherits from @vibesites-lineups-inc/theme-vibeoff-base and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-lineups-inc/theme-vibeoff-base/registry';
import { Hero } from './components/Hero';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Hero,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
